module.exports = __webpack_public_path__ + "img/1592157230.41e321cf.jpg";